import {ThemeProvider,applyTheme,readTheme} from './theme';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppErrorBoundary from "./components/AppErrorBoundary";
import "./index.css"; // Ensure styles are included if using Tailwind or custom styles

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min'; // includes Popper

applyTheme(readTheme());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <ThemeProvider><App /></ThemeProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
